'use client';
import React from 'react';

function SpeechSynthesisProvider() {
  return <></>;
}

export default SpeechSynthesisProvider;
